import { theme, baseTheme } from "@chakra-ui/react"

export default theme
export { baseTheme }
